import { render, staticRenderFns } from "./NewOtherTransaction.vue?vue&type=template&id=2d1c485a&"
import script from "./NewOtherTransaction.vue?vue&type=script&lang=js&"
export * from "./NewOtherTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports